import {Component, EventEmitter, Input, Output, Inject } from 'ng-metadata/core';




@Component({
selector: 'prm-action-container',
templateUrl: 'components/search/actions/actionContainer/action-container.html',
})


export class PrmActionContainer{
    @Input() item:Object;
    @Input() public selectedIds: Object;
    @Input() actionName: string;
    @Input() onToggle: Object;
    @Input() isFullView: boolean;
    @Output() closeTabsEvent = new EventEmitter<void>();

    constructor(@Inject('$element') private $element: ng.IRootElementService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,) {
    }
    ngOnInit() {
        this.$scope.$watch(()=>this.actionName === 'Citation', (newVal,oldVal)=>{
            this.$timeout(() => {
                this.setAriaRoleTab('md-nav-bar ul', 'tablist');
                this.setAriaRoleTab('md-nav-bar li', 'presentation');
                this.setAriaRoleTab('md-nav-bar button', 'tab');
            }, 400);
        });
    }


    throwCloseTabsEvent(){
        this.closeTabsEvent.emit(null); //throw this event to signal to actionList directive that you want to close the open action tab
    }

    //this function places role="tab" "Citation" action tab list
    private setAriaRoleTab(element, role){
        let actionButtons: [Element]= this.$element[0].querySelectorAll(element);
                    for(let li of actionButtons){
                li.setAttribute('role', role);
            }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/actionContainer/actionContainer.directive.ts